module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Os Fatores de Riscos listados abaixo devem ser vinculados aos riscos mostrados em Configurações > Riscos"
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Fator de Risco",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getFatorRisco,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "onFilter": _vm.getFatorRisco,
      "filterBadge": _vm.filterBadge
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-export"
    },
    slot: "table-export"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-download",
      "type": "text",
      "value": "Exportar para Excel",
      "title": "Clique aqui para exportar os dados para excel"
    },
    on: {
      "click": _vm.onExcel
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', [_c('ed-input-select-tipo', {
    staticClass: "col-12",
    attrs: {
      "label": "Filtrar por Categopria",
      "name": "cat_esocial",
      "tipo": "269",
      "valueKey": "descricao",
      "multiple": ""
    },
    model: {
      value: (_vm.formFilter.cat_esocial),
      callback: function($$v) {
        _vm.$set(_vm.formFilter, "cat_esocial", $$v)
      },
      expression: "formFilter.cat_esocial"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ea44d0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/fator-risco/index.vue
// module id = 1503
// module chunks = 45